module.exports = __webpack_public_path__ + "static/media/Add3.2da7b3a5.svg";